var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('download-link');
import { breakpoints, theme } from '@shapeable/theme';
import { Icons } from '../icons';
import { gtagEvent } from '../../utils/gtag';
export var DownloadLinkDefaultProps = {
  label: 'Download PDF',
  target: "_blank",
  backgroundColor: '#969696',
  hoverBackgroundColor: '#999999',
  color: 'light'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: none;\n    font-weight: 300;\n    text-transform: uppercase;\n    text-decoration: none;\n    box-sizing: border-box;\n    font-family: ", ";\n    font-size: 1em;\n    cursor: pointer;\n    display: flex;\n    padding: ", " ", ";\n    justify-content: space-between;\n\n    ", "\n  "], ["\n    border: none;\n    font-weight: 300;\n    text-transform: uppercase;\n    text-decoration: none;\n    box-sizing: border-box;\n    font-family: ", ";\n    font-size: 1em;\n    cursor: pointer;\n    display: flex;\n    padding: ", " ", ";\n    justify-content: space-between;\n\n    ", "\n  "])), theme.FONT('sans'), theme.UNIT(2.5), theme.UNIT(3), function (_a) {
    var _color = _a._color,
        _backgroundColor = _a._backgroundColor,
        _hoverBackgroundColor = _a._hoverBackgroundColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      background: ", ";\n      ", "; \n\n      &:hover {\n        background: ", ";\n      }\n    "], ["\n      color: ", ";\n      background: ", ";\n      ", "; \n\n      &:hover {\n        background: ", ";\n      }\n    "])), theme.COLOR(_color), theme.COLOR(_backgroundColor), theme.FILL(_color), theme.COLOR(_hoverBackgroundColor));
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 200px;\n  "], ["\n    width: 200px;\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme.UNIT(4))
}); // -------- Components -------->

var My = {
  Container: styled.a(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.span.attrs(cls.attr('label'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
export var DownloadLink = function DownloadLink(props) {
  var className = props.className,
      title = props.title,
      label = props.label,
      children = props.children,
      target = props.target,
      color = props.color,
      backgroundColor = props.backgroundColor,
      hoverBackgroundColor = props.hoverBackgroundColor;
  var download = props.download || process.env.PDF_DOWNLOAD_NAME;
  var url = props.url || "/pdf";

  var onClick = function onClick() {
    gtagEvent('page_view', {
      page_path: url
    });
  };

  return React.createElement(My.Container, {
    _hoverBackgroundColor: hoverBackgroundColor,
    _backgroundColor: backgroundColor,
    _color: color,
    onClick: onClick,
    target: target,
    download: download,
    title: title,
    className: cls.name(className),
    href: url || "/pdf"
  }, React.createElement(My.Label, null, children || label), React.createElement(Icons.Download, null));
};
DownloadLink.defaultProps = DownloadLinkDefaultProps;
DownloadLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;